import React, { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import Header from './components/Header';
import Cart from './components/Cart';
import CatalogList from './components/CatalogList';
import OrderStatus from './components/OrderStatus';

const ProductList = lazy(() => import('./components/ProductList'));
const Checkout = lazy(() => import('./components/Checkout'));

function App() {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch products from backend
  useEffect(() => {
    setIsLoading(true);
    axios
      .get('http://localhost:5000/api/products')
      .then(response => {
        setProducts(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error(error);
        setIsError(true);
        setIsLoading(false);
      });
  }, []);

  // Persist cart in local storage
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  // Add product to cart
  const addToCart = (product) => {
    setCart(prevCart => {
      const exist = prevCart.find(item => item.id === product.id);
      if (exist) {
        return prevCart.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
  };

  // Remove product from cart
  const removeFromCart = (productId) => {
    setCart(prevCart => prevCart.filter(item => item.id !== productId));
  };

  // Handle Checkout
  const handleCheckout = () => {
    const customer = {
      name: "John Doe",
      email: "john.doe@example.com",
      address1: "1234 Main Street",
      city: "Bologna",
      state_code: "BO",
      country_code: "IT",
      zip: "40100",
    };

    axios
      .post('http://localhost:5000/api/create-order', { items: cart, customer })
      .then(response => {
        // Handle successful order creation
        alert('Order placed successfully!');
      })
      .catch(error => {
        console.error(error);
        setIsError(true);
      });
  };

  return (
    <Router>
      <div className="App">
        <Header cartItemCount={cart.length} />
        <main className="main-content">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route
                path="/"
                element={
                  <ProductList products={products} addToCart={addToCart} isLoading={isLoading} />
                }
              />
              <Route
                path="/cart"
                element={
                  <Cart
                    cart={cart}
                    removeFromCart={removeFromCart}
                    handleCheckout={handleCheckout}
                    isError={isError}
                  />
                }
              />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/catalog" element={<CatalogList />} />
              <Route path="/order-status" element={<OrderStatus />} /> {/* New Route */}
            </Routes>
          </Suspense>
        </main>
      </div>
    </Router>
  );
}

export default App;
